import { useQuery } from 'react-query';
import { rootKeys } from '../cache-keys/rootKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { client_api } from '@axo/shared/data-access/api';

export function useClients() {
  const cacheKey = rootKeys.clients();
  const api = useAPI();

  return useQuery(cacheKey, client_api.getClients(api));
}

export function useClientEmail(clientID: string) {
  const cacheKey = rootKeys.clients();
  const api = useAPI();

  return useQuery(cacheKey, client_api.getClients(api), {
    enabled: !!clientID,
    select: (data): string => {
      if ((data.Items?.length || 0) < 1) return '';
      const client = data.Items.find((client) => client.ID === clientID);
      return client ? client.Email : '';
    },
  });
}
